import * as React from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { AddCircle } from "@mui/icons-material";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

export default function KeywordInput({ keywords, setKeywords }) {
  const [newK, setNewK] = React.useState("");

  const handleDelete = (chipToDelete) => () => {
    setKeywords((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  };

  const addKeyowrd = () => {
    if (newK !== "") {
      let keywordDocs = [...keywords];

      keywordDocs.push({ key: keywords.length, label: newK });

      setKeywords(keywordDocs);
      setNewK("");
    }
  };

  const keyPress = (e) => {
    if (e.keyCode == 13) {
      addKeyowrd();
    }
  };

  return (
    <Paper
      style={{ width: "92%", margin: "0 auto" }}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        p: 2,
      }}
      component="ul"
    >
      <p style={{ textAlign: "left" }}>Add Keywords</p>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          listStyle: "none",
        }}
      >
        {keywords?.map((data) => {
          let icon;

          return (
            <ListItem key={data.key}>
              <Chip
                icon={icon}
                label={data.label}
                onDelete={handleDelete(data)}
                sx={{
                  backgroundColor: "#339af0",
                  color: "#fff",
                  "& .MuiChip-deleteIcon": {
                    color: "#fff",
                  },
                }}
              />
            </ListItem>
          );
        })}
      </div>

      <TextField
        sx={{ mt: 2 }}
        id="input-with-icon-textfield"
        label="Add new keyword"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={addKeyowrd}>
                <AddCircle sx={{ color: "#339af0" }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
        variant="standard"
        value={newK || ""}
        onChange={(e) => setNewK(e.target.value)}
        onKeyDown={keyPress}
      />
    </Paper>
  );
}
